const localConfig = {
  NODE_ENV: process.env.NODE_ENV,
  APP_ENV: process.env.REACT_APP_APP_ENV,
  featureToggles: {
    'MANAGE_EMAILS': true
  },
  API_ROUTE_AWS: 'http://localhost:3001', // https://7qd1ucfzne.execute-api.us-east-1.amazonaws.com/dev
  API_LITIGATION: 'http://localhost:3002', // https://8rgo6d3hy5.execute-api.us-east-1.amazonaws.com/dev'
  API_PUBLICATION_ROUTE_AWS: 'https://j8o8w89613.execute-api.us-east-1.amazonaws.com/dev',
  API_IPD_ROUTE_USER: 'http://localhost:8085' // https://beta-secure.ipdanalytics.com/User
}
const devConfig = {
  ...localConfig,
  featureToggles: {
    'MANAGE_EMAILS': true
  },
  isProduction: false,
  API_ROUTE_AWS: 'https://7qd1ucfzne.execute-api.us-east-1.amazonaws.com/dev',
  API_LITIGATION: 'https://8rgo6d3hy5.execute-api.us-east-1.amazonaws.com/dev',
  API_PUBLICATION_ROUTE_AWS: 'https://j8o8w89613.execute-api.us-east-1.amazonaws.com/dev',
  API_IPD_ROUTE_USER: 'https://beta-secure.ipdanalytics.com/User'
}
const prodConfig = {
  ...localConfig,
  featureToggles: {
    'MANAGE_EMAILS': true
  },
  isProduction: true,
  API_ROUTE_AWS: 'https://tme1ebjjhf.execute-api.us-east-1.amazonaws.com/prod',
  API_LITIGATION: 'https://uxol6x6gjb.execute-api.us-east-1.amazonaws.com/prod',
  API_PUBLICATION_ROUTE_AWS: 'https://so1ho7h3tc.execute-api.us-east-1.amazonaws.com/prod',
  API_IPD_ROUTE_USER: 'https://secure.ipdanalytics.com/User'
}

const runningConfig = localConfig.NODE_ENV === 'production' && localConfig.APP_ENV === 'production'
  ? prodConfig
  : localConfig.APP_ENV === 'local' ? localConfig : devConfig
export default runningConfig
